import { Component } from "react";
import SearchParams from '../Elements/SearchParams';
import OtherFeeSearchParams from '../Contents/Sales/OtherFee/OtherFeeSearchParams';
import AuthService from "./authService.js";
import ServiceFeeItem from "../Domain/ServiceFeeItem";

class ServiceFeeService extends Component {
  static async GetActualLineItemValue(opportunityId) {
    const url = `/api/ServiceFee/GetActualLineItemValue/${opportunityId}?clearCache=false`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetServiceFeeItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, OtherFeeSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/ServiceFee/GetAllServiceFeeAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async RemoveServiceFee(serviceId) {
    const url = `/api/ServiceFee/RemoveServiceFee/${serviceId}`;
    return AuthService.getInstance().CallBackendFunctionDelete(url);
  }

  static PostServiceFee(item) {
    const url = "/api/ServiceFee/PostServiceFeeAsync/";
    const string = ServiceFeeService.toString(item);
    const json = JSON.stringify(string);

    return AuthService.getInstance().CallBackendFunctionPost(url, json);
  }

  static toString(o) {
    Object.keys(o).forEach((k) => {
      if (typeof o[k] === "object") {
        return toString(o[k]);
      }
      o[k] = `${o[k]}`;
    });
    return o;
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ServiceFeeItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}
export default ServiceFeeService;
